// SCI risk taxonomy. The scanner's classifier emits exactly four levels
// (apps/scanner/scoring/risk_classifier.py): legit | high | elevated | low.
// A domain that has been requested but not yet ranked has risk_level = NULL —
// that unranked queue is what the report surfaces as "Verify".
//
// Note `low` is not the safest band: it means no flags fired but there wasn't
// enough positive evidence to call the site legit.

export const RISK_COLOR = {
  legit: 'bg-[#65A542]',
  high: 'bg-[#B02418]',
  elevated: 'bg-[#DA7742]',
  low: 'bg-[#35749B]',
  verify: 'bg-[#8E3A8E]',
};

export const RISK_LABEL = {
  legit: 'Legit',
  high: 'High',
  elevated: 'Elevated',
  low: 'Low',
  verify: 'Verify',
};

export const BAND_DESCRIPTIONS = {
  legit: 'Legit - Site has no known security alerts. Associated with a reliable, recognized domain with a reputable company.',
  high: 'High - Site is identified as high-risk and should be avoided. Known to host malware, phishing attempts, or other malicious content.',
  elevated: 'Elevated - Site shows some risk indicators but may still be legitimate. Proceed with caution and verify before sharing personal information.',
  low: 'Low - Site has minor security concerns or outdated practices but generally safe. Monitor for updates and improvements.',
  verify: 'Verify - Site is queued for ranking and has not been rated yet. Treat as unverified until the scan completes.',
};

// Detail section order, matching the mockup (Legit first, unranked last).
export const BAND_ORDER = ['legit', 'high', 'elevated', 'low', 'verify'];

// Summary band order across the SCI Summary strip.
export const SUMMARY_ORDER = ['legit', 'high', 'elevated', 'low', 'verify'];

export function fmtDate(d) {
  if (!d) return 'Unknown';
  try {
    return new Date(d).toISOString().split('T')[0];
  } catch {
    return 'Unknown';
  }
}

export function deriveActiveDaysRange(whoisCreatedAt) {
  if (!whoisCreatedAt) return 'Unknown';
  const days = Math.floor((Date.now() - new Date(whoisCreatedAt).getTime()) / 86400000);
  if (days > 750) return '> 750';
  if (days >= 365) return '365–750';
  return '< 365';
}
